/**
 * As linhas que o painel de macros manda rodar no chat principal (`runInChat`). Elas vão para um chat
 * só: nesta janela, se um chat principal está montado aqui (com uma cópia dele, só um roda); senão,
 * para as janelas destacadas desta mesa, onde o chat pode estar. Pedida com o chat fora da tela (a aba
 * dele não está à vista), a linha espera um pouco que ele apareça.
 */

/** Quantos chats principais (sem canal) estão montados nesta janela. */
let mounted = 0;

/** O chat principal montou; devolve o que desmonta. */
export function registerMainChat(): () => void {
  mounted += 1;
  let gone = false;
  return () => {
    if (gone) return;
    gone = true;
    mounted -= 1;
  };
}

/** Há um chat principal nesta janela? */
export const mainChatHere = (): boolean => mounted > 0;

/** Quanto uma linha pedida sem chat à vista espera um aparecer. */
export const CHAT_RUN_TTL_MS = 15_000;

/** Um id que não se repete entre as janelas. */
export const newChatRunId = (): string => `run${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
